import { render, staticRenderFns } from "./DialogoBuscarProduto.vue?vue&type=template&id=a596f932&scoped=true&"
import script from "./DialogoBuscarProduto.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a596f932",
  null
  
)

export default component.exports